<template>
  <div>
    <div class="px-6 py-4" v-if="invoice.id" style="background: #F9FAFB;">
      <v-row class="mx-0" v-if="invoice.void_date">
        <hb-notification type="guidance" :notDismissable="true" class="mb-4">
          <template > 
            This invoice was voided on {{invoice.void_date | formatDate}} by {{ invoice.VoidedByContact.first | capitalize }} {{ invoice.VoidedByContact.last | capitalize }} {{ invoice.void_reason ? `for ${invoice.void_reason}`:'' }}.
          </template>
        </hb-notification> 
      </v-row>
      <v-row class="mx-0" v-else-if="invoice.ReissuedFrom.number">
        <hb-notification type="guidance" :notDismissable="true" class="mb-4">
          <template > 
            This invoice was reissued from Invoice #{{invoice.ReissuedFrom.number}} on {{invoice.date | formatDate}}.
          </template>
        </hb-notification> 
      </v-row>
      <v-row class="mx-0">
        <v-col :cols="12" :sm="5" :md="5" :lg="5" class="pa-0" :class="{'pr-4': !$vuetify.breakpoint.xs, 'mb-4': $vuetify.breakpoint.xs}">
          <v-card :class="{'hb-elevation-medium': !$vuetify.breakpoint.xs , 'box-shadow-none':  $vuetify.breakpoint.xs}" class="hb-border-default">
            <v-card-title class="pa-4 pb-0">
              <span class="subtitle-1 font-weight-medium text-capitalize">{{invoice.Contact.first}} {{invoice.Contact.last}} </span>
            </v-card-title>
            <v-card-text class="px-4">
              <span class="subtitle-1" v-if="invoice.Contact.Phones && invoice.Contact.Phones.length > 0">{{invoice.Contact.Phones[0].phone | formatPhone}} </span><br>
              <span class="subtitle-1"> {{contactAddress.address}}</span><br>
              <span class="subtitle-1" v-if="contactAddress"> {{ contactAddress | formatAddress }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col :cols="12" :sm="7" :md="7" :lg="7" class="pa-0">
          <v-card v-if="!$vuetify.breakpoint.xs"  class="hb-elevation-medium hb-border-default">
            <v-card-title class="d-flex align-center ma-0 pa-0 inv-header-cell" style="flex-wrap: unset;">
              <v-col cols="4" class="d-flex align-center">
                <span class="ml-3 subtitle-1 font-weight-medium">Invoice ID:</span>
              </v-col>
              <v-divider  vertical></v-divider>
              <v-col cols="4" class="d-flex align-center">
                <span class="ml-3 subtitle-1 font-weight-medium">Invoice Date:</span>
              </v-col>
              <v-divider  vertical></v-divider>
              <v-col cols="4" class="d-flex align-center">
                <span class="ml-3 subtitle-1 font-weight-medium">Due Date</span>
              </v-col>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="d-flex pa-0 ma-0 hb-default-font-size">
              <v-col cols="4" class="d-flex mt-2 justify-center">
                <span class="subtitle-1 font-weight-regular hb-text-night">{{invoice.number}}</span>
              </v-col>
              <v-divider  vertical></v-divider>
              <v-col cols="4" class="d-flex mt-2">
                <div class="subtitle-1 font-weight-regular hb-text-night text-center">{{invoice.created_at | addTimeOffset(getPropertyOffset(), 'MMM DD, YYYY h:mma z')}}</div> 
              </v-col>
              <v-divider  vertical></v-divider>
              <v-col cols="4" class="d-flex mt-2 pr-0">
                <span class="ml-3 subtitle-1 font-weight-regular hb-text-night">{{invoice.due | formatDate}}</span> 
              </v-col>
            </v-card-text>
          </v-card>

          <v-card v-if="$vuetify.breakpoint.xs" :class="{'hb-elevation-medium': !$vuetify.breakpoint.xs, 'box-shadow-none':  $vuetify.breakpoint.xs}" class="hb-border-default py-4">
            <v-card-title class="px-4 py-0 pb-0">
              <span class="subtitle-1 font-weight-medium text-capitalize mr-2">Invoice ID: </span> <span class="subtitle-1 font-weight-regular hb-text-night">{{invoice.number}}</span>
            </v-card-title>
            <v-card-title class="px-4  py-0 pb-0">
              <span class="subtitle-1 font-weight-medium text-capitalize mr-2">Invoice Date: </span> <span class="subtitle-1 font-weight-regular hb-text-night">{{invoice.date | formatDate}}</span>
            </v-card-title>
            <v-card-title class="px-4 py-0 pb-0">
              <span class="subtitle-1 font-weight-medium text-capitalize mr-2">Due Date: </span> <span class="subtitle-1 font-weight-regular hb-text-night">{{invoice.due | formatDate}}</span>
            </v-card-title>
            
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mx-0 mt-4">
        <v-col class="pa-0">

          <v-card v-if="$vuetify.breakpoint.xs" class="hb-border-default mb-4 mobile-table" elevation="0">
            <v-row  class="d-flex pa-0 py-1 mx-0 mb-0 space-description col-width-500">
              <v-col cols="12" class="d-flex align-center py-1">
                <span class="ml-3 subtitle-2 font-weight-medium subtitle-2-mobile" v-if="invoice.Lease && invoice.Lease.Unit">Space #{{invoice.Lease.Unit.number || ''}}</span> 
                <span class="subtitle-2 font-weight-regular ml-1 subtitle-2-mobile"> - Invoice #{{invoice.number || ''}}</span>
                <span class="ml-1 subtitle-2 font-weight-medium subtitle-2-mobile" v-if="invoice.paid === 0"> - Due Date: {{invoice.due | formatDate}}</span>
                <span class="ml-1 subtitle-2 font-weight-medium subtitle-2-mobile" v-else> <hb-icon small class="mt-0 ml-0 mr-1 position-relative hb-check-circle-icon" color="success">mdi-check-circle</hb-icon> Paid</span>
              </v-col>
            </v-row>
            <v-card-title class="d-flex align-center ma-0 pa-0 inv-header-cell col-width-500" style="flex-wrap: unset;">
              <v-col :cols="isAdjusted ? 7 : 4" class="d-flex align-center col-width-250">
                <span class="ml-3 subtitle-2 font-weight-medium">Description</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-end px-0 col-width-50">
                <span class="subtitle-2 font-weight-medium">Qty</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end px-0 col-width-100">
                  <span class="subtitle-2 font-weight-medium">Rate</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end px-0" v-if="!isAdjusted">
                <span class="subtitle-2 font-weight-medium">Tax</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end pl-0 col-width-100">
                <span class="subtitle-2 font-weight-medium">Total</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-end pl-0 col-width-150" v-if="!isAdjusted">
                <span class="subtitle-2 font-weight-medium">Credit</span>
              </v-col>
            </v-card-title>
            <v-divider class="col-width-500"></v-divider>
            <v-card-text class="pa-0 ma-0 hb-default-font-size">
              
              <v-row class="d-flex pa-0 mx-0 align-center" style="flex-wrap: unset;" v-for="(line, index) in invoice.InvoiceLines" :key="index">
                <v-col :cols="isAdjusted ? 7 : 4" class="d-flex align-center py-1 col-width-250">
                  <div v-if="line.Service && line.Service.service_type === 'insurance'">
                    <span class="ml-3 subtitle-2 font-weight-medium hb-text-night">Protection Plan</span>
                    <span style="font-size:10px;"> ({{line.Product.name}})</span>
                  </div>
                  <div v-else-if="line.Service && line.Service.service_type !=='insurance' && line.Service.recurring === 1">
                    <span class="ml-3 subtitle-2 font-weight-medium hb-text-night">
                      {{line.Product.name}} 
                    </span>
                    <span style="font-size:10px;color:#637381">({{  invoice.period_start | formatDate}} - {{ invoice.period_end | formatDate}})</span>
                  </div>
                  <span v-else class="ml-3 subtitle-2 font-weight-medium hb-text-night">
                    {{line.Product.name}}
                  </span>


                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end px-0 py-1 col-width-50" :class="{'pr-1' : isAdjusted}">
                  <v-text-field
                      v-if="isAdjusted"
                      hide-details
                      single-line
                      type="number"
                      v-validate="'required|max:45|min_value:1'"
                      required
                      :id="'qty-'+index"
                      name="quantity"
                      v-model="line_qty[index]"
                      @input="refreshInvoiceData"
                      class="px-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                  ></v-text-field>
                  <span v-else class="subtitle-2 font-weight-regular hb-text-night">{{line.qty}}</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end px-0 py-1 col-width-100">
                  <v-text-field
                      v-if="isAdjusted"
                      hide-details
                      single-line
                      type="number"
                      v-validate="'required|min_value:0.01'"
                      required
                      :id="'cost-'+index"
                      name="rate"
                      v-model="line_costs[index]"
                      @input="refreshInvoiceData"
                      prefix="$"
                      class="pa-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                  ></v-text-field>
                  <span v-else class="subtitle-2 font-weight-regular hb-text-night">{{line.full_cost | formatMoney}}</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end px-0 py-1" v-if="!isAdjusted">
                  <span class="subtitle-2 font-weight-regular hb-text-night">{{line.total_tax | formatMoney}}</span>
                </v-col>
                <v-col cols="2" :class="isAdjusted ? 'text-right pl-0 py-1 top-8px' : 'd-flex align-center justify-end text-right pl-0 py-1'">
                  <span class="subtitle-2 font-weight-regular hb-text-night">{{line | lineTotal(isAdjusted) | formatMoney}}</span><br/>
                  <div v-if="isAdjusted">
                    <hb-link @click="removeProduct(index)">Remove</hb-link>
                  </div>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end pl-2 py-1 col-width-150"  v-if="eligibleForCredit(line) && canAdjust">
                  <hb-menu options small>
                      <v-list>
                          <v-list-item :ripple="false" @click="showCreditModal(line)">
                              <v-list-item-title>Issue Credit</v-list-item-title>
                          </v-list-item>
                      </v-list>
                  </hb-menu>
                  <v-text-field
                    single-line
                    hide-details
                    v-validate="'required|max:45'"
                    required
                    :id="'credit-'+line.id"
                    :name="'credit-'+line.id"
                    v-model="creditAmounts[line.id]"
                    prefix="$"
                    class="pa-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                  ></v-text-field>

                  <div class="pl-1">
                    <hb-link @click="updateCreditAmount(line, creditAmounts[line.id])">Credit</hb-link>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mx-0" v-if="isAdjusted && $vuetify.breakpoint.xs">
                <v-col cols="7" class="d-flex align-center">
                  <hb-link class="ml-3" v-if="!showAddProduct" @click="showAddProduct = true">+ Add a product or service</hb-link>
                  <v-autocomplete
                    v-else
                    :items="products"
                    dense
                    item-text="name"
                    item-value="id"
                    return-object
                    label="Search for product or services"
                    v-model="product"
                    @input="addProductToInvoice"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    single-line
                    outlined
                    class="ml-3 mb-2"
                  >
                    <template v-slot:item="{ item }">
                      <v-row class="mx-0" style="max-width: 320px">
                        <v-col class="pa-1 font-weight-medium pb-0" md="9">{{ item.name }}</v-col>
                        <v-col class="pa-1 text-right font-weight-medium pb-0" md="3">{{ item.price | formatMoney }}</v-col>
                        <v-col v-if="item.description" md="9" class="pa-1 pt-0">{{ item.description }}</v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end pl-2 py-1" v-if="!isAdjusted">
                  <v-text-field
                    single-line
                    hide-details
                    v-validate="'required|max:45'"
                    required
                    :id="'credit-'+line.id"
                    :name="'credit-'+line.id"
                    v-model="creditAmounts[line.id]"
                    prefix="$"
                    class="pa-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                    type="number"
                    :min="0"
                    :max="getMaxCredit(line)"
                    @input="validateCreditAmount(line, $event)"
                  ></v-text-field>

                  <div class="pl-1">
                    <hb-link @click="updateCreditAmount(line, creditAmounts[line.id])">Credit</hb-link>
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex align-center justify-end px-0 py-1"></v-col>
                <v-col cols="2" v-if="showAddProduct" class="d-flex align-center justify-end pl-0 py-1">
                    <hb-link @click="showAddProduct = false">Remove</hb-link>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>



          <v-card class="hb-border-default" elevation="0">
            <v-row  v-if="!$vuetify.breakpoint.xs" class="d-flex pa-0 mx-0 space-header mb-1">
                <v-col cols="5" class="d-flex align-center py-1">
                  <span class="ml-3 subtitle-2 font-weight-medium " v-if="invoice.Lease && invoice.Lease.Unit">Space #{{invoice.Lease.Unit.number || ''}}</span>
                </v-col>
                <v-col cols="7" class="d-flex align-center py-1 pl-0 justify-end">
                  <span class="subtitle-2 font-weight-regular">Invoice #{{invoice.number || ''}}</span>
                  <span class="ml-1 subtitle-2 font-weight-medium" v-if="invoice.paid === 0"> - Due Date: {{invoice.due | formatDate}}</span> 
                  <span class="ml-1 subtitle-2 font-weight-medium" v-else> - Paid</span>
                </v-col>
              </v-row>
            <v-card-title v-if="!$vuetify.breakpoint.xs" class="d-flex align-center ma-0 pa-0 inv-header-cell" style="flex-wrap: unset;">
              <v-col :cols="isAdjusted ? 7 : 4" class="d-flex align-center">
                <span class="ml-3 subtitle-2 font-weight-medium">Description</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-end px-0">
                <span class="subtitle-2 font-weight-medium">Qty</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end px-0">
                  <span class="subtitle-2 font-weight-medium">Rate</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end px-0" v-if="!isAdjusted">
                <span class="subtitle-2 font-weight-medium">Tax</span>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-end pl-0">
                <span class="subtitle-2 font-weight-medium">Total</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-end pl-0"  v-if="!isAdjusted">
                <span class="subtitle-2 font-weight-medium">Credit</span>
              </v-col>
            </v-card-title>
            <v-divider v-if="!$vuetify.breakpoint.xs"></v-divider>
            <v-card-text class="pa-0 ma-0 hb-default-font-size">
              
              <v-row v-if="!$vuetify.breakpoint.xs" class="d-flex pa-0 mx-0" v-for="(line, index) in invoice.InvoiceLines" :key="index">
                <v-col :cols="isAdjusted ? 7 : 4" class="d-flex align-center py-1">
                  <div v-if="line.Service && line.Service.service_type === 'insurance'">
                    <span class="ml-3 subtitle-2 font-weight-medium hb-text-night">Protection Plan</span>
                    <span style="font-size:10px;"> ({{line.Product.name}})</span>
                  </div>
                  <div v-else-if="line.Service && line.Service.service_type !=='insurance' && line.Service.recurring === 1">
                    <span class="ml-3 subtitle-2 font-weight-medium hb-text-night">
                      {{line.Product.name}} 
                    </span>
                    <span style="font-size:10px;">({{  invoice.period_start | formatDate}} - {{ invoice.period_end | formatDate}})</span> 
                  </div>
                  <span v-else class="ml-3 subtitle-2 font-weight-medium hb-text-night">
                    {{line.Product.name}}
                  </span>


                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end px-0 py-1" :class="{'pr-1' : isAdjusted}">
                  <v-text-field
                      v-if="isAdjusted"
                      hide-details
                      single-line
                      type="number"
                      v-validate="'required|max:45|min_value:1'"
                      required
                      :id="'qty-'+index"
                      name="quantity"
                      v-model="line_qty[index]"
                      @input="refreshInvoiceData"
                      class="px-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                  ></v-text-field>
                  <span v-else class="subtitle-2 font-weight-regular hb-text-night">{{line.qty}}</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end px-0 py-1">
                  <v-text-field
                      v-if="isAdjusted"
                      hide-details
                      single-line
                      type="number"
                      v-validate="'required|min_value:0.01'"
                      required
                      :id="'cost-'+index"
                      name="rate"
                      v-model="line_costs[index]"
                      @input="refreshInvoiceData"
                      prefix="$"
                      class="pa-0 mt-0 view-invoice-txt-field pb-2 pt-1"
                  ></v-text-field>
                  <span v-else class="subtitle-2 font-weight-regular hb-text-night">{{line.full_cost | formatMoney}}</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end px-0 py-1" v-if="!isAdjusted">
                  <span class="subtitle-2 font-weight-regular hb-text-night">{{line.total_tax | formatMoney}}</span>
                </v-col>
                <v-col cols="2" :class="isAdjusted ? 'text-right pl-0 py-1 top-8px' : 'd-flex align-center justify-end text-right pl-0 py-1'">
                  <span class="subtitle-2 font-weight-regular hb-text-night">{{line | lineTotal(isAdjusted) | formatMoney}}</span><br/>
                  <div v-if="isAdjusted">
                    <hb-link @click="removeProduct(index)">Remove</hb-link>
                  </div>
                </v-col>
              <v-col cols="1" class="d-flex align-center justify-end pl-2 py-1" v-if="eligibleForCredit(line)">
                <hb-menu options small>
                      <v-list>
                          <div v-if="!hasLineCreditPermission.allowed || isIPP()">
                            <hb-tooltip >
                              <template v-slot:item >
                                <v-list-item disabled :ripple="false">
                                  <v-list-item-title>Issue Credit</v-list-item-title>
                                </v-list-item>
                              </template>
                              <template v-slot:body>{{ lineCreditTooltipText }}</template>
                            </hb-tooltip> 
                          </div>
                          <div v-else>
                            <v-list-item :ripple="false" @click="showCreditModal(line)">
                              <v-list-item-title>Issue Credit</v-list-item-title>
                          </v-list-item>
                          </div>                      
                      </v-list>
                  </hb-menu>
              <!-- <v-text-field
                single-line
                hide-details
                v-validate="'required|max:45'"
                required
                :id="'credit-'+line.id"
                :name="'credit-'+line.id"
                v-model="creditAmounts[line.id]"
                prefix="$"
                class="pa-0 mt-0 view-invoice-txt-field pb-2 pt-1"
              ></v-text-field>

              <div class="pl-1">
                <hb-link @click="updateCreditAmount(line, creditAmounts[line.id])">Credit</hb-link>
              </div> -->
              <CreditModal
                v-model="creditModal"
                v-if="creditModal"
                :line="selectedLine"
                :invoice="invoice"
                @voidModal="voidModal"
              />
            </v-col>


              </v-row>
              <v-row class="mx-0" v-if="isAdjusted && !$vuetify.breakpoint.xs">
                <v-col cols="7" class="d-flex align-center">
                  <hb-link class="ml-3" v-if="!showAddProduct" @click="showAddProduct = true">+ Add a product or service</hb-link>
                  <v-autocomplete
                    v-else
                    :items="products"
                    dense
                    item-text="name"
                    item-value="id"
                    return-object
                    label="Search for product or services"
                    v-model="product"
                    @input="addProductToInvoice"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    single-line
                    outlined
                    class="ml-3 mb-2"
                  >
                    <template v-slot:item="{ item }">
                      <v-row class="mx-0" style="max-width: 320px">
                        <v-col class="pa-1 font-weight-medium pb-0" md="9">{{ item.name }}</v-col>
                        <v-col class="pa-1 text-right font-weight-medium pb-0" md="3">{{ item.price | formatMoney }}</v-col>
                        <v-col v-if="item.description" md="9" class="pa-1 pt-0">{{ item.description }}</v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="3" class="d-flex align-center justify-end px-0 py-1"></v-col>
                <v-col cols="2" v-if="showAddProduct" class="d-flex align-center justify-end pl-0 py-1">
                    <hb-link @click="showAddProduct = false">Remove</hb-link>
                </v-col>
              </v-row>
              <v-divider class="mt-1"  v-if="!$vuetify.breakpoint.xs"></v-divider>
              <v-row class="d-flex pa-0 mx-0">
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 10" class="d-flex align-center justify-end px-0 py-1">
                  <span class="subtitle-1">Subtotal:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex align-center justify-end pl-0 py-1">
                  <span class="subtitle-1">{{ subTotal | formatMoney }}</span>
                </v-col>
              </v-row>
              <v-row class="d-flex pa-0 mx-0">
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 10" class="d-flex align-center justify-end px-0 py-0">
                  <span class="subtitle-1">Discount:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex align-center justify-end pl-0 py-0">
                  <span class="subtitle-1">{{promotionTotal | formatMoney }}</span>
                </v-col>
              </v-row>
              <v-row class="d-flex pa-0 mx-0">
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 10" class="d-flex align-center justify-end px-0 py-1">
                  <span class="subtitle-1">Tax:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex align-center justify-end pl-0 py-1">
                  <span class="subtitle-1">{{taxSum | formatMoney }}</span>
                </v-col>
              </v-row>
              <v-row class="d-flex pa-0 mx-0">
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 10" class="d-flex align-center justify-end px-0 py-0">
                  <span class="subtitle-1 font-weight-medium">Invoice Total:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex align-center justify-end pl-0 py-0">
                  <span class="subtitle-1 font-weight-medium">{{invoiceTotal | formatMoney }}</span>
                </v-col>
              </v-row>
              <v-divider class="mt-2"></v-divider>
              <v-row class="d-flex pa-0 mx-0 inv-header-cell">
                <v-col v-if="!$vuetify.breakpoint.xs" :cols="$vuetify.breakpoint.xs ? 4 : 7" class="d-flex pb-0 pt-2" style="flex-direction:column;">
                  <span class="subtitle-1 font-weight-medium" v-if="!isAdjusted && invoice.Payments.length > 0">Payment(s) made:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 3" class="d-flex  justify-end text-right pa-0 pt-2">
                  <span class="subtitle-1">Total Payment received:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex  justify-end pa-0 pt-2 pr-3">
                  <span class="subtitle-1">{{ totalPayments | formatMoney }}</span>
                </v-col>
              </v-row>
              <v-row v-if="$vuetify.breakpoint.xs && !isAdjusted && invoice.Payments.length > 0" class="d-flex pa-0 mx-0 inv-header-cell">
                <v-col :cols="12" class="d-flex pb-0 pt-0" style="flex-direction:column;" >
                  <div v-if="!isAdjusted" class="pb-0">
                    <div
                      :class="{ 'cursor-pointer' : !fromMasterVueFile }"
                      class="text-right"
                      v-for="p in invoice.Payments"
                      :key="p.payment_id"
                      @click="!fromMasterVueFile ? showPamentDetails(p) : ''"
                    >
                      <span v-if="p.PaymentMethod" :class="{ 'hb-payment' : !fromMasterVueFile }">
                        {{ p.Payment.payment_source | capitalize }} - {{p.date | formatDate}}
                      </span>
                      <span v-else-if="p.Payment.method == 'credit'" :class="{ 'hb-payment' : !fromMasterVueFile }">
                        Credit - {{p.date | formatDate}}
                      </span>
                      <span v-else-if="p.Payment.method == 'adjustment'" :class="{ 'hb-payment' : !fromMasterVueFile }">
                         Adjustment: {{SUB_METHOD[p.Payment.sub_method]}} - {{p.date | formatDate}}
                      </span>
                      <span v-else :class="{ 'hb-payment' : !fromMasterVueFile }">
                        <span class="text-capitalize" :class="{ 'hb-payment' : !fromMasterVueFile }">{{p.Payment.payment_source | capitalize}} - {{p.date | formatDate}}</span>
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="d-flex pa-0 mx-0 inv-header-cell">
                <v-col v-if="!$vuetify.breakpoint.xs" :cols="$vuetify.breakpoint.xs ? 4 : 7" class="d-flex pb-0 pt-2" style="flex-direction:column;" >
                  <div v-if="!isAdjusted && invoice.Payments.length > 0" class="pb-2">
                    <div
                      :class="{ 'cursor-pointer' : !fromMasterVueFile }"
                      v-for="p in invoice.Payments"
                      :key="p.payment_id"
                      @click="!fromMasterVueFile ? showPamentDetails(p) : ''"
                    >
                      <span v-if="p.PaymentMethod" :class="{ 'hb-payment' : !fromMasterVueFile }">
                        Payment applied on {{p.date | formatDate}} - {{p.amount | formatMoney}}
                      </span>
                      <span v-else-if="p.Payment.method == 'credit'" :class="{ 'hb-payment' : !fromMasterVueFile }">
                        Credit applied on {{p.date | formatDate}} - {{p.amount | formatMoney}}
                      </span>
                      <span v-else-if="p.Payment.method == 'adjustment'" :class="{ 'hb-payment' : !fromMasterVueFile }">
                        {{SUB_METHOD[p.Payment.sub_method]}} adjustment applied on {{p.date | formatDate}} - {{p.amount | formatMoney}}
                      </span>
                      <span v-else :class="{ 'hb-payment' : !fromMasterVueFile }">
                        <span class="text-capitalize" :class="{ 'hb-payment' : !fromMasterVueFile }">{{p.Payment.payment_source}}</span>
                        payment applied on {{p.date | formatDate}} - {{p.amount | formatMoney}}
                      </span>
                    </div>
                  </div>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 9 : 3" class="d-flex justify-end px-0 pt-0">
                  <span class="title font-weight-medium">Balance Due:</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 3 : 2" class="d-flex justify-end pl-0 pt-0">
                  <span class="title font-weight-medium">{{ balanceDue | formatMoney }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>


      </v-row>
    </div>
  </div>
</template>

<script type="text/babel">

import api from '../../assets/api.js'; 
import moment from 'moment';
import { EventBus } from '../../EventBus.js';
import { mapGetters } from 'vuex';
import ADJUSTMENT from "@/constants/adjustment.js";
import { notificationMixin } from  '../../mixins/notificationMixin.js';
import CreditModal from './CreditModal.vue';


export default {
  name: "ViewInvoice",
  mixins: [notificationMixin],
  data() {
      return {
          invoice:{},
          payments:[],
          showAddProduct:false,
          showMakePayment:false,
          products: [],
          charge:{
              product_id: null,
              service_id: null,
              cost: null,
              qty: null
          },
          product:{},
          creditAmounts: {},     
          creditModal: false, 
          selectedLine: null,
          line_costs: [],
          line_qty: [],
      }
  },

  created (){
    this.SUB_METHOD = ADJUSTMENT.SUB_METHOD;
    this.invoice = this.selected;
    this.searchProducts();
  },
  mounted() {
    this.invoice.InvoiceLines.forEach((line, index) => {
      this.$set(this.creditAmounts, line.id, 0); 
      this.line_costs[index] = line.full_cost;
      this.line_qty[index] = line.qty;
    });
  },
  filters:{
    lineTotal(c, isAdjusted){
      return (c.qty * c.cost) + (isAdjusted ? 0 : c.total_tax);
    }
  },
  components: {
    CreditModal,
  },
  computed:{
    ...mapGetters({
        isAdmin: 'authenticationStore/isAdmin',
        hasPermission: 'authenticationStore/rolePermission',
        properties: 'propertiesStore/filtered',
    }),
    isPastDue(){
        return this.balanceDue && moment() > moment(this.invoice.due, 'MM/DD/YYYY');
    },
    balanceDue(){
      return this.invoiceTotal - this.totalPayments;
    },
    totalPayments(){
      return this.invoice.Payments.reduce(function(a, b){
        return a + b.amount;
      }, 0)
    },
    promotionTotal() {
      if (this.isAdjusted) {
      let discountTotal = 0;
      if (!Array.isArray(this.invoice?.InvoiceLines)) return 0;

      this.invoice.InvoiceLines.forEach((line) => {
        if (Array.isArray(line?.DiscountLines)) {
          discountTotal += line.DiscountLines.reduce((a, b) => a + b.amount, 0);
        }
      });

      return Math.round(discountTotal * 1e2) / 1e2;
      } else {
        return this.invoice?.discounts ?? 0;
      }
    },
    taxSum() {
      if (this.isAdjusted) {
        let taxSum = 0;

        if (!Array.isArray(this.invoice?.InvoiceLines)) return 0;

        this.invoice.InvoiceLines.forEach(line => {
          if (Array.isArray(line?.TaxLines)) {
            line.TaxLines.forEach(tLine => {
              const lineTax = Math.round((Number(tLine?.amount) || 0) * 1e2) / 1e2;
              taxSum += lineTax;
            });
          }
        });

        return taxSum;
      } else {
        return Math.round((Number(this.invoice?.total_tax) || 0) * 1e2) / 1e2;
      }
    },
    subTotal() {
      if (this.isAdjusted) {
        if (!Array.isArray(this.invoice?.InvoiceLines)) return 0;

        return this.invoice.InvoiceLines.reduce((a, b) => {
          const cost = Number(b.cost) || 0;
          const qty = Number(b.qty) || 1;
          return a + Math.round((cost * qty) * 1e2) / 1e2;
        }, 0);
      } else {
        return this.invoice?.sub_total ?? 0;
      }
    },
    invoiceTotal(){
      return this.taxSum + this.subTotal - this.promotionTotal;
    },
    contactAddress() {
      if(this.invoice) {
        return this.invoice.Contact.Addresses.length > 0 ? this.invoice.Contact.Addresses[0].Address: ''
      }
    },
    hasLineCreditPermission() {
        const today = moment().startOf("day").format("YYYY-MM-DD");
        const periodStart = moment(this.invoice.period_start).startOf("day").format("YYYY-MM-DD");
        const periodEnd = moment(this.invoice.period_end).endOf("day").format("YYYY-MM-DD");

        let invoicePhase = '';
        if (moment(today).isBefore(periodStart)) {
          invoicePhase = "future";
        } else if (moment(today).isBetween(periodStart, periodEnd, null, '[]')) {
          invoicePhase = "current";
        } else {
            invoicePhase = "past";
        }
        const hasInvoiceLineCreditPermission = this.hasPermission('invoice_line_credit');
        const hasInvoiceLineCreditPermissionForClosedMonth = this.hasPermission('credit_closed_month_invoice_line') && hasInvoiceLineCreditPermission;
    
        return {
          allowed: invoicePhase === "past" ? hasInvoiceLineCreditPermissionForClosedMonth : hasInvoiceLineCreditPermission,
          phase: invoicePhase,
          basePermission: hasInvoiceLineCreditPermission,
          closedMonthPermission: hasInvoiceLineCreditPermissionForClosedMonth
        };
        
    },
    lineCreditTooltipText() {
      const permission = this.hasLineCreditPermission;
      if (!permission.basePermission) {
        return 'You do not have the required permission to perform this action.';
      }
      if (permission.phase === 'past' && !permission.closedMonthPermission) {
        return 'Crediting is restricted for invoices from closed months.';
      }
      if (this.isIPP()) {
        return 'Line-level credits cannot be applied to invoice lines paid through Inter Property Payments.';
      }
    }
  },
  methods: {
    showCreditModal: function(line){
      this.selectedLine = line
      this.creditModal = true;
    },
    voidModal: function(data){
      this.$emit('close');
      this.$emit("open-void-modal", { is_credited: data.isCredited, refundAmount: data.refundAmount, line: data.line, creditAmount: data.creditAmount}); 
    },
    showPamentDetails(p){
      EventBus.$emit('show_lease_payment', p.payment_id)
    },
    payInvoice(){
        this.$router.push('/invoices/pay/'+ this.invoice_id)
    },
    leaseEvents(){
        this.fetchData();
        this.fetchPayments();
    },
    closeDropdown(){
        //TODO JQUERY FIX
        // $(event.target).closest('.dropdown-menu').dropdown('toggle');
    },
    prevent(event){
        event.stopPropagation();
    },
    fetchData(){
        if(!this.invoice_id) return;
        api.get(this, api.INVOICES + this.invoice_id).then(r => {
            this.invoice = r.invoice;
            this.invoice.date = this.$options.filters.formatDate(this.invoice.date);
            this.invoice.due = this.$options.filters.formatDate(this.invoice.due);
        });
    },
    fetchPayments(){
        if(!this.invoice_id) return;
        api.get(this, api.INVOICES + this.invoice_id + '/payments').then(r => {
            this.payments = r.payments;
            this.payments.date = this.$options.filters.formatDate(this.payments.date);
        });
    },
    unapplyPayment(p){
        api.delete(this, api.PAYMENTS + 'apply/', p.id).then(r => {
            this.$refs.unapplyDropdown[0].away();
            EventBus.$emit('lease_payment_saved');
        });
    },
    removeProduct(index){
      if(this.invoice.InvoiceLines){
        this.invoice.InvoiceLines.splice(index, 1);
        this.line_costs.splice(index, 1);
        this.line_qty.splice(index, 1);
      }
    },
    away(){
        return this.openSuggestion = false;
    },
    email(){

    },
    download(){

    },
    getPropertyOffset(){
        let currentProperty = this.properties.find(p => this.invoice?.Property?.id === p.id);
        let offSet = currentProperty ? currentProperty?.utc_offset : "Etc/UTC";
        return offSet;
    },
    cancelUnapply(){
        this.$refs.unapplyDropdown[0].away()
    },
    searchProducts(search){
        var params = `type[]=product&type[]=late&search=&lease_id=${this.invoice.lease_id}`;
        api.get(this, api.PRODUCTS + `list?${params}`).then(r => {
            this.products = r.products;
        });

    },
    eligibleForCredit(line){
      let amount = line.subtotal + line.total_tax - line.total_discounts;
      
      if (!this.isAdjusted && 
          line.can_credit === true && 
          this.invoice.void_date === null && 
          amount > 0) {
        return true;
      }
      return false;
    },
    isIPP() {
      return this.invoice.Payments && 
        this.invoice.Payments.some(payment => payment.Payment.sub_method === 'inter_property_payment');
    },
    getMaxCredit(line) {
      return (line?.subtotal + line?.total_tax);
    },
    validateCreditAmount(line, event) {
      let enteredAmount = event?.target?.value ? parseFloat(event.target.value) : this.creditAmounts[line.id];
      if (isNaN(enteredAmount) || enteredAmount === "" || enteredAmount === null) {
        this.creditAmounts[line.id] = 0;
        return;
      }
      let maxCredit = this.getMaxCredit(line);
      console.log(maxCredit,"maxCredit");

      if (enteredAmount > maxCredit) {
        this.showMessageNotification({
          type: "error",
          description: `Credit amount cannot exceed the total line charge ($${maxCredit}).`
        });
      } 
    },

    updateCreditAmount(line, creditAmount) {
      let amount = parseFloat(creditAmount);

      const unpaidAllocation = line.line_pending_amount || 0; 
      const paidAllocation = line.line_item_amount_paid + line.line_tax_amount_paid|| 0;
      const availableCredit = unpaidAllocation + paidAllocation;
      const maxCredit = line.subtotal + line.total_tax || 0;

      if (amount > maxCredit) {
        console.error("Entered credit amount exceeds the maximum allowable credit for this line.");
        this.showMessageNotification({
          type: "error",
          description: `Entered credit amount ($${amount}) exceeds the total line charge ($${maxCredit}).`
        });
        return;
      }
      const taxPercentage = line?.total_tax > 0 && line.cost > 0 ? (line?.total_tax / line.cost) * 100 : 0;
      console.log("Tax Percentage:", taxPercentage);

      const taxOnCredit = (amount * taxPercentage) / 100;
      console.log("Tax on Credit:", taxOnCredit);
      amount = Number(creditAmount) + taxOnCredit;
      console.log("totalCreditAmount with tax",amount);

      let line_total = line.cost + line.total_tax - line.total_discounts;
      let line_adjustments = line.LineAllocations
        .filter(ila => ila.Payment.credit_type == 'adjustment')
        .reduce((total, ila) => total + ila.total_allocation, 0);

      if ((Math.round((amount + line_adjustments) * 1e2) / 1e2) > line_total){
        this.showMessageNotification({
          type: "error",
          description: `Adjustment cannot be credited`
        });
        return;
      }

      if (amount <= unpaidAllocation) {
        console.log(`Crediting ${amount} to the unpaid balance.`);
        const payload = { amount };
        api.post(this, api.INVOICES + `${this.invoice.id}/invoice_line/${line.id}/credit`, payload)
          .then((response) => {
            console.log("Credit updated successfully", response);
            this.invoice = response.invoice;
          })
          .catch((error) => {
            console.error("Failed to update credit", error);
          });
        return;
      }

      if (amount > unpaidAllocation) {
        const creditAmount = parseFloat(unpaidAllocation.toFixed(2));
        const refundAmount = parseFloat((amount - creditAmount).toFixed(2));
        console.log("creditAmount",creditAmount);
        console.log("refundAmount", refundAmount);
        console.log(`Crediting $${creditAmount} to the unpaid balance and refunding $${refundAmount} via void modal.`);
        if(creditAmount > 0 && refundAmount > 0){
          console.log("Inside credit and refund");
          this.$emit("open-void-modal", { is_credited: true, refundAmount: refundAmount, line: line, creditAmount : creditAmount }); 
        } else {
        if (creditAmount > 0) {
          const payload = { amount: creditAmount };
          api.post(this, api.INVOICES + `${this.invoice.id}/invoice_line/${line.id}/credit`, payload)
            .then((response) => {
              console.log("Credit updated successfully", response);
              this.invoice = response.invoice;
            })
            .catch((error) => {
              console.error("Failed to update credit", error);
            });
        }
        if (refundAmount > 0) {
          console.log("Inside refund");
          this.$emit("open-void-modal", { is_credited: true, refundAmount: refundAmount, line: line, creditAmount : creditAmount }); 
        }
      }
      }

    },

    refreshInvoiceData: _.debounce(function() {
      if(this.isAdjusted){
        this.invoice.InvoiceLines.forEach((line, index) => {
          line.full_cost = this.line_costs[index];
          line.qty = this.line_qty[index];
        })
        this.$emit('refreshInvoice');
      }
		}, 800),

    addProductToInvoice(product){
      if((!product || !product.id) || this.invoice.InvoiceLines.find( line => line.product_id === product.id)) {
          this.product = {};
          return;
      }

      var newLine = {
        
          Product: product,
          product_id: product.id,
          cost: product.price || 0,
          full_cost: product.price || 0,
          qty: this.charge.qty || 1,
          DiscountLines:[],
          TaxLines:[],
      };

      this.invoice.InvoiceLines.push(newLine);
      this.line_costs.push(newLine.full_cost);
      this.line_qty.push(newLine.qty);
      this.$emit('refreshInvoice');

      this.charge = {
          product_id: null,
          cost: null,
          qty: null
      };
      this.product = {};
    }
  },
  props:['selected', 'readonly', 'isAdjusted', 'refreshInvoice', 'fromMasterVueFile', 'canAdjust'],
  watch:{
    selected:function(newInvoice){
      this.invoice = newInvoice;
    }
  }
}

</script>

<style scoped>

  span{
    color: #101318;
  }

  .inv-header-cell{
    background: #F4F6F8;
  }

  .space-header {
    background: #F9FAFB;
    box-shadow: inset 0px -1px 0px #DFE3E8;
  }
  .hb-payment {
    color: #306FB6;
  }
  .top-8px{
    position:relative;
    top:8px
  }
  .hb-check-circle-icon {
    top: -1px
  }
  .mobile-table {
    overflow-x: scroll;
  }

  @media (max-width: 430px) { 
    .subtitle-2-mobile {
      font-size: 0.700rem !important;
    }
  }
  @media (max-width: 600px) { 
    .box-shadow-none {
      box-shadow: unset !important;
    }
    .space-description {
      background-color: #F9FAFB;
    }
  }
</style>

<style lang="scss">
  .view-invoice-txt-field {
    max-width: 50px;
    .v-input__slot {
      &:before {
        border-color: rgba(0, 0, 0, 0.15) !important;
        border-bottom-left-radius: 5px;
      };
      input {
        text-align: right !important;
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }
  .view-invoice-txt-field input[type="number"]::-webkit-outer-spin-button,
  .view-invoice-txt-field input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 600px) {
    // Loop to create width classes from 1px to 500px
    @for $i from 1 through 1000 {
      .col-width-#{$i} {
        flex: 0 0 #{$i}px;
        max-width: #{$i}px;
        width: #{$i}px;
      }
    }
  }
</style>